import React from 'react';

type DeviceInfoPanelProps = {
  macAddress: string;
  localIpAddress: string | null;
  streamUrl: string | null;
  relayIngestUrl: string | null;
  relayControlUrl: string | null;
};

type InfoRowProps = {
  label: string;
  value: string | null | undefined;
  title?: string;
};

const InfoRow: React.FC<InfoRowProps> = ({ label, value, title }) => (
  <div className="d-flex justify-content-between gap-2 py-1 border-bottom">
    <span className="text-muted text-nowrap" title={title}>
      {label}
    </span>
    <span className="text-end text-break" style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
      {value && value.trim() !== '' ? value : '—'}
    </span>
  </div>
);

const DeviceInfoPanel: React.FC<DeviceInfoPanelProps> = (props) => (
  <div className="mt-3">
    <div className="fw-semibold mb-1">Device</div>
    <InfoRow label="MAC Address" value={props.macAddress} />
    <InfoRow label="Local IP" value={props.localIpAddress} />
    <InfoRow
      label="Stream URL"
      value={props.streamUrl}
      title="Direct stream address (from device check-in)."
    />
    <InfoRow
      label="Relay Ingest"
      value={props.relayIngestUrl}
      title="UDP target for the streaming device to send audio to the relay."
    />
    <InfoRow
      label="Relay Control"
      value={props.relayControlUrl}
      title="TCP control endpoint for inmate clients when using the relay."
    />
  </div>
);

export default DeviceInfoPanel;
